// extracted by mini-css-extract-plugin
var _1 = "BrandGoBack_root__3ae47";
export { _1 as "root" }
